export type Props = {
  imgSrc: string
}

const HeroContainer = ({ imgSrc }: Props) => {

  const backgroundImgStyle = 'url(' + imgSrc + ')'
  const heroStyle = {
    height: '100%',
    width: '100%',
    backgroundSize: 'cover',
    backgroundImage: backgroundImgStyle,
    backgroundPosition: '50% 50%'
  }

  return <div className="hero-container short">
    <div style={heroStyle}></div>
  </div>
}

export default HeroContainer
